import React from 'react';
import { Typography, Card } from 'antd';
import { PageContainer } from '@/components/profile/styles/SubscriptionsPage.styles';

const { Title, Paragraph } = Typography;

const PrivacyPolicyPage: React.FC = () => {
  return (
    <PageContainer>
      <Card>
        <Title level={2}>Политика конфиденциальности</Title>
        <Paragraph strong>Последнее обновление: 2026 г.</Paragraph>

        <Title level={4}>1. Общие положения</Title>
        <Paragraph>
          Настоящая политика конфиденциальности определяет порядок обработки и защиты персональных данных
          пользователей сервиса управления турнирами по карате (далее — Сервис). Использование Сервиса
          означает согласие пользователя с данной политикой.
        </Paragraph>

        <Title level={4}>2. Какие данные мы собираем</Title>
        <Paragraph>
          При регистрации и использовании Сервиса мы можем обрабатывать: адрес электронной почты, имя и фамилию,
          данные организации (название клуба, федерации), данные об участниках турниров (ФИО, дата рождения,
          весовая категория и иные данные, необходимые для проведения соревнований), технические данные
          (IP-адрес, тип браузера, cookies) в объёме, необходимом для работы Сервиса и безопасности.
        </Paragraph>

        <Title level={4}>3. Цели обработки данных</Title>
        <Paragraph>
          Персональные данные используются для: создания и ведения учётной записи; организации и проведения
          турниров; коммуникации с пользователями; обработки платежей (в том числе через платёжные системы,
          например ЮKassa); улучшения работы Сервиса и соблюдения требований законодательства.
        </Paragraph>

        <Title level={4}>4. Cookies и аналогичные технологии</Title>
        <Paragraph>
          Сервис использует cookies и локальное хранилище для: аутентификации пользователя, обеспечения
          безопасности (в том числе защита от CSRF), сохранения настроек. Отключение cookies может ограничить
          возможность использования Сервиса.
        </Paragraph>

        <Title level={4}>5. Передача данных третьим лицам</Title>
        <Paragraph>
          Данные могут передаваться: платёжным провайдерам (например, ЮKassa) — в объёме, необходимом для
          проведения оплаты; хостинг- и техническим провайдерам — для обеспечения работы Сервиса; по требованию
          уполномоченных государственных органов в случаях, предусмотренных законом.
        </Paragraph>

        <Title level={4}>6. Хранение и защита данных</Title>
        <Paragraph>
          Данные хранятся на защищённых серверах в течение срока, необходимого для целей обработки, и в
          соответствии с применимым законодательством. Применяются организационные и технические меры для
          защиты от несанкционированного доступа, изменения или уничтожения данных.
        </Paragraph>

        <Title level={4}>7. Ваши права</Title>
        <Paragraph>
          Вы имеете право: запросить доступ к своим персональным данным, их исправление или удаление; отозвать
          согласие на обработку (где применимо); направить жалобу в уполномоченный орган по защите персональных
          данных. Для реализации прав обратитесь к нам по контактам, указанным в разделе «Контакты».
        </Paragraph>

        <Title level={4}>8. Изменения политики</Title>
        <Paragraph>
          Мы вправе обновлять настоящую политику. Актуальная версия публикуется на этой странице с указанием
          даты последнего обновления. Продолжение использования Сервиса после изменений означает принятие
          обновлённой политики.
        </Paragraph>

        <Title level={4}>9. Контакты</Title>
        <Paragraph>
          По вопросам, связанным с обработкой персональных данных и политикой конфиденциальности, вы можете
          связаться с нами через раздел «Обратная связь» (Контакты) на сайте.
        </Paragraph>
      </Card>
    </PageContainer>
  );
};

export default PrivacyPolicyPage;
